/* eslint-disable react/no-children-prop,no-array-constructor,@typescript-eslint/no-array-constructor,no-useless-return */
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Card } from "@progress/kendo-react-layout";
import styled from "styled-components";
import { Droppable } from "react-beautiful-dnd";
import FtlRouteHeader from "./FtlRouteHeader/FtlRouteHeader";
import { EditProjectContext } from "../../EditProjectContext";
import { FtlRouteViewModel } from "../../../ViewModel/FtlRouteViewModel";
import { CardType } from "../../LeftSide/CardType";
import { isProjectReadOnly as isProjectReadonly } from "../../IsProjectReadOnly";
import { FtlRouteCard } from "./FtlRouteCard";
import { ReadOnlyProps } from "../../ReadOnlyProps";

const StyledFtlCard = styled(Card)`
  height: 100%;
  padding: 11px 18px;
  margin: 1rem 0;
`;

export const FtlTab = ({ isReadOnly }: ReadOnlyProps) => {
  const { project, setProject } = useContext(EditProjectContext);
  const projectReadonly = isProjectReadonly(project);

  const [expanded, setExpanded] = useState<Array<number>>([]);

  const toggleCardExpansion = (panel: number) => {
    if (expanded.includes(panel)) {
      const array = [...expanded]; // make a separate copy of the array
      const index = array.indexOf(panel);
      if (index !== -1) {
        array.splice(index, 1);
        setExpanded(array);
      }
    } else {
      setExpanded([...expanded, panel]);
    }
  };

  const [routeIds, setRouteIds] = useState<Array<number>>([]);

  function updateLaunchBatches() {
    const routes = project.FTLRoutes;
    const routesWithoutLaunchBatch = routes?.filter((r) => r.LaunchBatch === null);
    const sharedRoutesWithoutLaunchBatch = new Array();

    routesWithoutLaunchBatch?.forEach((route) => {
      // If route is already in sharedRoutes -> skip
      if (
        sharedRoutesWithoutLaunchBatch.some((shared) =>
          shared.map((r: any) => r.RouteId).includes(route.RouteId)
        )
      ) {
        return;
      }

      // Add at least this route
      const shared = new Array(route);

      const spdrIds = route.SpdrsOnThisRoute?.map((spdr) => spdr.SpdrId);

      const hasMatchingElement = (listA: any, listB: any) => {
        return listA.some((element: any) => listB.includes(element));
      };
      // Search for routes with the same SPDR on them
      const otherRoutes = routesWithoutLaunchBatch.filter((r) => r.RouteId !== route.RouteId);
      otherRoutes.forEach((otherRoute) => {
        const otherSpdrIds = otherRoute.SpdrsOnThisRoute?.map((spdr) => spdr.SpdrId);
        // If there is another route with the same SPDR, add to shared
        if (hasMatchingElement(spdrIds, otherSpdrIds)) {
          shared.push(otherRoute);
        }
      });

      sharedRoutesWithoutLaunchBatch.push(shared);
    });

    sharedRoutesWithoutLaunchBatch.forEach((sharedRoutes) => {
      const maxLaunchBatch = getMaxLaunchBatch();
      const nextLaunchBatch = maxLaunchBatch < 9 ? maxLaunchBatch + 1 : 9;

      sharedRoutes.forEach((route: FtlRouteViewModel) => {
        setLaunchBatch(route.RouteId, nextLaunchBatch);
      });
    });
  }

  const setLaunchBatch = (routeId: any, launchBatch: number) => {
    const updateFtlRoute = (ftlRoute: FtlRouteViewModel) => {
      return ftlRoute.RouteId === routeId
        ? {
            ...ftlRoute,
            LaunchBatch: launchBatch,
          }
        : ftlRoute;
    };

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    });
  };

  const init = () => {
    let value = 1;
    setRouteIds([]);
    let updateLaunchBatch = false;

    project.FTLRoutes?.forEach((element) => {
      setRouteIds([...routeIds, value]);
      value += 1;
      if (element.LaunchBatch === null) {
        updateLaunchBatch = true;
      }
    });

    if (updateLaunchBatch) {
      updateLaunchBatches();
    }
  };

  function getMaxLaunchBatch() {
    const launchBatches = project.FTLRoutes?.filter((r) => r.LaunchBatch !== null).map(
      (r) => r.LaunchBatch
    );
    if (launchBatches && launchBatches.length > 0) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return Math.max(...launchBatches);
    }
    return 0;
  }

  useEffect(() => {
    init();
  }, []);

  return (project.FTLRoutes?.length || 0) === 0 ? (
    <div>No Routes added</div>
  ) : (
    <div>
      {project.FTLRoutes?.map((ftlRoute) => {
        return (
          <div key={ftlRoute.RouteId.toString() ?? ""}>
            <Droppable
              ignoreContainerClipping
              droppableId={ftlRoute.RouteId.toString() ?? ""}
              key={ftlRoute.RouteId.toString() ?? ""}
              type={CardType.dragCard}
            >
              {(provided, snapshot) => {
                return (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    <StyledFtlCard
                      key={ftlRoute.RouteId}
                      style={{
                        border: snapshot.isDraggingOver
                          ? "1px solid #ffcc00"
                          : "1px solid rgba(0, 0, 0, 0.08)",
                      }}
                    >
                      <FtlRouteHeader
                        route={ftlRoute}
                        toggleCardExpansion={toggleCardExpansion}
                        isReadonly={projectReadonly || isReadOnly}
                      />
                      {expanded.includes(ftlRoute.RouteId) ? (
                        <FtlRouteCard
                          ftlRoute={ftlRoute}
                          isReadOnly={projectReadonly || isReadOnly}
                        />
                      ) : (
                        <div />
                      )}
                    </StyledFtlCard>
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>

            {}
          </div>
        );
      })}
    </div>
  );
};
